import React, { ChangeEvent, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Input, Row } from 'antd';
import debounce from 'lodash.debounce';
import { ERoutesPrivate } from 'common/models/routesModel';
import { useQueryFilter } from 'common/hooks/useQueryFilter';
import { useIsContentRestricted } from 'common/hooks/useIsContentRestricted';
import { EBitecoinPageTabKeys } from 'app/pages/Franchisor/BitecoinPage';
import { BitecoinRewardStatusSelector } from 'entities/Bitecoin/components/BitecoinRewardStatusSelector';
import { ECommonEntityStatus, IBitecoinRewardCollectionFilter } from 'entities/Bitecoin/Bitecoin.models';
import { BitecoinRewardsTable } from 'entities/Bitecoin/components/BitecoinRewardsTable';
import { bitecoinRewardTableConfig } from 'entities/Bitecoin/Bitecoin.const';

export const BitecoinRewards: React.FC = () => {
  const canManageRewards = !useIsContentRestricted();
  const defaultFilter: IBitecoinRewardCollectionFilter = useMemo(
    () => ({
      pageIndex: 1,
      tab: EBitecoinPageTabKeys.RewardItems,
      search: undefined,
      status: undefined,
    }),
    []
  );

  const { filter, updateFilter } = useQueryFilter(defaultFilter);

  const autocompleteSearch = useCallback(
    debounce((text: string) => {
      updateFilter({ search: text === '' ? undefined : text });
    }, 300),
    [updateFilter]
  );

  const onChangeStatus = (status: ECommonEntityStatus | undefined) => updateFilter({ status });

  return (
    <>
      <Row className="mb-10 width-full" justify="space-between" align="bottom">
        <Col span={20}>
          <Row justify="start" align="bottom">
            <Col span={8} className="mr-4">
              <span className="mb-3">Search by name</span>
              <Input.Search
                placeholder="Search by name"
                defaultValue={filter.search}
                onChange={(e: ChangeEvent<HTMLInputElement>) => autocompleteSearch(e.target.value)}
                className="mt-3"
              />
            </Col>
            <Col span={8}>
              <BitecoinRewardStatusSelector onChangeStatus={onChangeStatus} value={filter.status} />
            </Col>
          </Row>
        </Col>
        <Col span={4}>
          <Link to={ERoutesPrivate.BitecoinRewardCreate}>
            <Button block type="primary" title="Add New Reward" disabled={!canManageRewards}>
              Add New Reward
            </Button>
          </Link>
        </Col>
      </Row>
      <BitecoinRewardsTable config={bitecoinRewardTableConfig} filter={filter} />
    </>
  );
};
